module.exports = __webpack_public_path__ + "img/card_brasov_background.e3d77e0b.png";